import { useQuery } from '@tanstack/react-query';

import { useIamApiInstance } from '../api';
import { HOST_QUERY_KEY } from '../constants';
import useServiceAppState from './useServiceAppState';

import type { ResponseCloudUser } from '../api';

const useFetchUserDetailInfo = () => {
  const {
    state: { userId },
  } = useServiceAppState();

  const { fetchUserDetailInfo } = useIamApiInstance();

  return useQuery<ResponseCloudUser>({
    queryKey: [HOST_QUERY_KEY.GET_IAM_USER_DETAIL_INFO],
    queryFn: () => fetchUserDetailInfo({ userId }),
  });
};

export default useFetchUserDetailInfo;
